<!-- src/app/components/newsletter-signup/newsletter-signup.component.html -->
<div class="newsletter-signup">
  <div class="newsletter-signup__icon">✉</div>
  <h3>Stay Informed</h3>
  <p>Get the latest press releases and campaign updates from Lydia Christensen for U.S. Senate delivered to your inbox.</p>

  <form (ngSubmit)="onSubmit()" class="signup-form">
    <div class="form-group">
      <label for="name">Name</label>
      <input
        type="text"
        id="name"
        [(ngModel)]="formData.name"
        name="name"
        placeholder="Your name"
        [disabled]="isSubmitting"
      />
    </div>
    <div class="form-group">
      <label for="email">Email</label>
      <input
        type="email"
        id="email"
        [(ngModel)]="formData.email"
        name="email"
        placeholder="your@email.com"
        [disabled]="isSubmitting"
      />
    </div>
    <button type="submit" [disabled]="isSubmitting">
      {{ isSubmitting ? 'Signing up...' : 'Sign Up for Updates' }}
    </button>
  </form>

  <div *ngIf="successMessage" class="newsletter-success">{{ successMessage }}</div>
  <div *ngIf="errorMessage" class="newsletter-error">{{ errorMessage }}</div>
</div>
